import Modal, { ModalBody, Sheets, Theatre } from "@ingka/modal";
import classNames from "classnames";
import React from "react";

type Props = {
  children: React.ReactNode;
  hideModal: () => void;
  modalVisible: boolean;
  modalType?: string;
  ariaLabel: string;
  className?: string;
  size?: "small" | "medium" | "large";
};

const GenericModal = ({
  children,
  hideModal,
  modalVisible,
  ariaLabel,
  modalType = "sheets",
  className,
  size = "medium",
}: Props) => {
  return (
    <Modal handleCloseBtn={hideModal} visible={modalVisible} escapable>
      {modalType === "theatre" ? (
        <Theatre
          aria-label={ariaLabel}
          header={null}
          className={classNames(className && className)}
        >
          <ModalBody className="flex h-screen flex-col">{children}</ModalBody>
        </Theatre>
      ) : (
        <Sheets
          alignment="right"
          aria-label={ariaLabel}
          size={size}
          header={null}
          footer={null}
          className={classNames(className && className)}
        >
          <ModalBody>{children}</ModalBody>
        </Sheets>
      )}
    </Modal>
  );
};

export default GenericModal;
